import type { Dispatch, SetStateAction } from 'react';
import type { NewMediaUploadFn } from '../hooks/api/useMediaUpload';
import type {
  ContentTypeDefinition,
  WithOptionalInternalProps,
} from '../lib/flotiq-client/types/api-response';

import { createContext } from 'react';

interface ContentTypeFormContextProps {
  oldCtd?: WithOptionalInternalProps<ContentTypeDefinition> | null;
  setDirty: Dispatch<SetStateAction<boolean>>;
  disabled: boolean;
  isEditing: boolean;
  onMediaUpload?: NewMediaUploadFn;
  propertiesErrors: Record<string, any>;
}

export const ContentTypeFormContext =
  createContext<ContentTypeFormContextProps>({
    setDirty: () => false,
    disabled: false,
    isEditing: false,
    propertiesErrors: {},
  });

export default ContentTypeFormContext;
